import { AppThunk } from 'app/store'
import { getRateTypes } from 'services'
import { slice } from './reducer'

export const {
  fetchRateTypeStart,
  fetchRateTypeSuccess,
  fetchRateTypeFailed,
  selectRateType,
} = slice.actions

export const fetchRateTypes = (): AppThunk => async (dispatch) => {
  dispatch(fetchRateTypeStart())
  try {
    const data = await getRateTypes()
    dispatch(fetchRateTypeSuccess(data))
  } catch (err) {
    dispatch(fetchRateTypeFailed())
  }
}
